import { render, staticRenderFns } from "./precheck.vue?vue&type=template&id=dee94e96"
import script from "./precheck.vue?vue&type=script&lang=js"
export * from "./precheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports